/** El acceso al contenido de una cohorte vence al pasar su content_access_deadline. Sin fecha = vigente. */
export function isEnrollmentExpired(
  e: { content_access_deadline?: string | null } | null | undefined,
  now: Date = new Date(),
): boolean {
  const d = e?.content_access_deadline;
  return !!d && new Date(d).getTime() < now.getTime();
}

/** Una selección guardada no equivale a una elección explícita en Contenido. */
export function shouldOpenAllContent(input: {
  expired: boolean; paidAccess: boolean; explicitSelection: boolean;
  perpetual: boolean; viewOnly: boolean;
}): boolean {
  return input.expired && input.paidAccess && !input.explicitSelection && !input.perpetual && !input.viewOnly;
}

export function contentAccessSource(enterprise: boolean, pro: boolean): 'enterprise' | 'pro' | 'cohort' {
  return enterprise ? 'enterprise' : pro ? 'pro' : 'cohort';
}

/** Selección por defecto: cohorte con acompañamiento activa y vigente primero. */
export function pickDefaultEnrollment<T extends { is_perpetual: boolean; status: string | null; content_access_deadline?: string | null; view_only?: boolean }>(
  enrollments: T[],
  now: Date = new Date(),
): T | null {
  const own = enrollments.filter(e => !e.view_only);
  if (own.length === 0) return null;
  const valid = (e: T) => !isEnrollmentExpired(e, now);
  return (
    own.find(e => !e.is_perpetual && e.status === 'active' && valid(e)) ??
    own.find(e => !e.is_perpetual && valid(e)) ??
    own.find(e => !e.is_perpetual && e.status === 'active') ??
    own.find(e => !e.is_perpetual) ??
    own[0]
  );
}
